import type { ReactNode } from 'react'
import { Modal } from './Modal'

/**
 * Explicit confirm for a destructive or posture-changing action. Nothing is sent until
 * the confirm button is pressed; Cancel / Escape / backdrop close send nothing.
 */
export function ConfirmAction({
  title,
  children,
  confirmLabel,
  pendingLabel = 'Working…',
  danger = true,
  pending,
  error,
  onConfirm,
  onClose,
}: {
  title: string
  children: ReactNode
  confirmLabel: string
  pendingLabel?: string
  danger?: boolean
  pending: boolean
  error?: ReactNode
  onConfirm: () => void
  onClose: () => void
}) {
  return (
    <Modal
      title={title}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn" onClick={onClose}>Cancel</button>
          <button
            type="button"
            className={danger ? 'btn btn--danger' : 'btn btn--primary'}
            onClick={() => !pending && onConfirm()}
            disabled={pending}
            aria-busy={pending}
          >
            {pending ? pendingLabel : confirmLabel}
          </button>
        </>
      }
    >
      {children}
      {error ? <p className="form-error" role="alert">{error}</p> : null}
    </Modal>
  )
}
